
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { Box, Menu, MenuItem, getContrastRatio } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "@fontsource/rubik";
import { getInitials, getStringBeforeChar, logout, resetAllState } from "../../../utils/commonServices";
// import { customTheme as theme } from "../../../theme/customTheme";
import useCustomTheme from "../../../theme/useCustomTheme";

const useStyles = makeStyles((theme) => ({
  center: {
    //  display:'flex',
    //   alignItems: 'center',
    //   justifyContent:'center'
  },
  text: {
    color: theme.palette.primary.dark,
    fontSize: theme.typography.subtitle2,
    fontWeight: theme.typography.fontWeightBold,
  
  },
}));

const GuestUserCard = (props) => {

  const classes = useStyles();
  const { avatarImg, userName, size = 'small' } = props;
  const [theme ] = useCustomTheme()
  const guestReducer = useSelector(state=> state.guestReducer)
   const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch()
  const navigate = useNavigate()
  
    const commonReducer = useSelector((state) => state.root.commonReducer);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  return (
    <Box
      {...props}
      className='flex row a-center j-center'
      spacing={2}
    >

    <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', cursor:commonReducer.is_logged == true && 'pointer'}} onClick={commonReducer.is_logged == true ? handleClick : null}  gap={2}>

        { 
          size == "small" ?<Avatar sx={{width:{xs:'20px',sm:'24px' ,md:'27px' , lg:'26px' ,xl:'35px'}, height:{xs:'20px',sm:'24px' ,md:'27px' , lg:'26px' ,xl:'35px'},backgroundColor:theme.palette.primary.main, borderRadius:'8px', fontSize:{xs:'8px',md:'10px',lg:'12px',xl:'16px'}, fontWeight: 600, textTransform:'uppercase',  color:getContrastRatio( theme.palette.primary.main , '#ffffff') > 2.5 ? '#ffffff' : '#000000'}}>{guestReducer?.guest_name ? getInitials(guestReducer?.guest_name) :getInitials('Guest User')  }</Avatar>
        :  <Avatar sx={{width:{xs:'20px',sm:'22px' ,md:'24px' , lg:'25px' ,xl:'35px'}, height:{xs:'20px',sm:'22px' ,md:'24px' , lg:'25px' ,xl:'35px'},backgroundColor:theme.palette.primary.main, borderRadius:'8px', fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, fontWeight: 600, textTransform:'uppercase',   color:getContrastRatio( theme.palette.primary.main , '#ffffff') > 2.5 ? '#ffffff' : '#000000'}}>{guestReducer?.guest_name ? getInitials(guestReducer?.guest_name) :getInitials('Guest User')  }</Avatar>}
        <Typography
          className={classes.text}
          variant="body2"
          sx={{
            fontFamily: 'Rubik',
            fontSize: {xs:'10px',md:'12px',lg:'14px',xl:'20px'},
            fontWeight: 600,
            color: 'black !important',
            textTransform:'capitalize'
          }}
        >
          {guestReducer?.guest_name ? getStringBeforeChar(guestReducer?.guest_name, "|") : 'Guest User'}
        </Typography>
    </Box>
    <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
    
        transformOrigin={{
              vertical: -8,
              horizontal: 'right',
             }}
      >
  
      {commonReducer.is_logged === true ? (
        <>
          {/* Menu items for logged-in users */}
          {/* <MenuItem
            onClick={() => {
              navigate('/myfiles')
              handleClose();
            }}
            sx={{color:'#000',fontWeight:600, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4, height: {xs:25, xl:32}, '&:hover':{backgroundColor:`${theme.palette.primary.main}70`}}}
          >
           My Files
          </MenuItem> */}

          {/* {commonReducer?.is_admin && <MenuItem
            onClick={() => {
              if(commonReducer?.is_company_name_available === false){
                dispatch(setAssetState({brand_name_popup: true}))
              }else{ 
                dispatch(updateState({change_theme_popup:true}))
              }
              handleClose();
            }}
            sx={{color:'#000',fontWeight:600, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4, height: {xs:25, xl:32},  '&:hover':{backgroundColor:`${theme.palette.primary.main}70`}}}
          >
           White Label Assets
          </MenuItem>} */}

          {/* {commonReducer?.is_admin && <MenuItem
            style={{ height: 25 }}
            onClick={() => {
              if(commonReducer?.is_company_name_available === false){
                dispatch(setAssetState({brand_name_popup: true, brand_box_clicked: true}))
              }else{
                navigate('/brandbox')
              }
              handleClose();
            }}
            sx={{'&:hover':{backgroundColor:`${theme.palette.primary.main}70`},color:'#000',fontWeight:600, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4}}
          >
           My Brandbox
          </MenuItem>} */}

          {/* <MenuItem
            onClick={() => {
              dispatch(updateState({account_delete_popup : true}))
              setAnchorEl(null)
            }}
            sx={{color:'#000',fontWeight:600, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4, height:{xs:25, xl:32},  '&:hover':{backgroundColor:`${theme.palette.primary.main}70`}}}
          >
            Delete Account
          </MenuItem> */}

          <MenuItem
            onClick={() => {
              resetAllState(dispatch)
              window.localStorage.removeItem("device_info_slug");
              logout(dispatch);
              window.localStorage.setItem('logout_all', "true")
              window.localStorage.clear();
              window.location.href=`${process.env.REACT_APP_COPILOT_URL}/redirect?request=logout`;
              handleClose();
            }}
            sx={{color:'#000',fontWeight:600, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4, height:{xs:25, xl:32},  '&:hover':{backgroundColor:`${theme.palette.primary.main}70`}, minWidth:'150px'}}
          >
            Log out
          </MenuItem>
        </>
      ) : (
        <>
          {/* Menu items for guest users */}
          <MenuItem
            onClick={() => {
              resetAllState(dispatch)
              window.localStorage.removeItem("device_info_slug");
              logout(dispatch);
              window.localStorage.setItem('logout_all', "true")
              window.localStorage.clear();
              window.location.href=`${process.env.REACT_APP_COPILOT_URL}/redirect?request=logout`;
              handleClose();
            }}
            sx={{color:'#000',fontWeight:600, fontFamily:'Rubik', letterSpacing:0.8, fontSize:{xs:'8px',md:'10px',lg:'11px',xl:'16px'}, py:0.4, height:{xs:25, xl:32},  '&:hover':{backgroundColor:`${theme.palette.primary.main}70`}, minWidth:'150px'}}
          >
            Log out
          </MenuItem>
        </>
      )}
       
      </Menu>
    </Box>
  );
};

export default GuestUserCard;